import React from "react";
import { EXISTING_MODES, INTENTS, existingModeCopy } from "../../import/intent";

const ExistingChooser = ({ match, intent, mode, onChange, busy }) => {
  const existing = match?.summary?.existing || 0;
  const possible = match?.summary?.possible || 0;
  if (!existing && !possible) return null;
  if (intent === INTENTS.ROUTES_ONLY) {
    return (
      <section className="start-ask start-ask--quiet">
        <h3>
          {existing} registered student{existing === 1 ? " was" : "s were"} found
        </h3>
        <p className="start-muted">
          They will be placed on the services named in the file. Nobody is created or changed.
          {possible > 0 ? ` ${possible} more look similar — pick a match for them in the list below.` : ""}
        </p>
      </section>
    );
  }

  return (
    <section className="start-ask" aria-labelledby="start-existing-title">
      <h3 id="start-existing-title">
        {existing > 0
          ? `${existing} of these students ${existing === 1 ? "is" : "are"} already registered`
          : `${possible} of these names look familiar`}
        {busy && <span className="start-ask__busy"> · checking…</span>}
      </h3>
      {existing > 0 && (
        <div className="start-ask__options start-ask__options--row" role="radiogroup" aria-label="Registered students">
          {[EXISTING_MODES.SKIP, EXISTING_MODES.UPDATE, EXISTING_MODES.ADD].map((option) => {
            const copy = existingModeCopy(option);
            const selected = mode === option;
            return (
              <button
                key={option}
                type="button"
                role="radio"
                aria-checked={selected}
                className={`start-ask__option${selected ? " is-selected" : ""}`}
                onClick={() => onChange(option)}
              >
                <span className="start-ask__radio" aria-hidden="true" />
                <span className="start-ask__body">
                  <strong>{copy.title}</strong>
                  <span>{copy.detail}</span>
                </span>
              </button>
            );
          })}
        </div>
      )}
      {possible > 0 && (
        <p className="start-muted start-ask__reason">
          {possible} name{possible === 1 ? "" : "s"} match{possible === 1 ? "es" : ""} a registered student but the school or phone differs. They
          are treated as new unless you decide otherwise in the list below.
        </p>
      )}
    </section>
  );
};

export default ExistingChooser;
